import { createAsyncThunk } from "@reduxjs/toolkit";
import { createThunkName } from "~/rocketchat/redux/createThunkNamespace";
import type { ThunkBase } from "~/rocketchat/redux/types";
import { setSelectedChannelId } from "../channelSlice";

type SelectChannelThunkPayload = {
  channelId: string;
};
export const selectChannelThunk = createAsyncThunk<
  void,
  SelectChannelThunkPayload,
  ThunkBase
>(
  createThunkName("selectChannelThunk"),
  async ({ channelId }, { dispatch }) => {
    dispatch(setSelectedChannelId(channelId));
  },
);
